import React, { useState,useEffect } from "react";
import useUserInfo from "../../Hooks/useUserInfo";
import "../PhaseDetails/PhaseDetails.css";
import "../stakepoints/points.css";
import { logPageView } from "../../components/analytics";
import PhasePage from "../PhasePage/PhasePage";
import cancelIcon from "../../assets/Task/cancelicon.svg";
import cancelbtn from "../../assets/Task/cancelicon1.png";
import { useAudio } from "../../Providers/AudioProvider";
const Info = () => {
  const { userDetails, updateUserInfo } = useUserInfo();
  useEffect(() => {
    logPageView("StakeDetails", "StakeDetails page");
  }, []);
  const [showPopup, setShowPopup] = useState(false);
  const playClick = useAudio();
  const [selectedNumber, setSelectedNumber] = useState(80);
  const handleChange = (event) => {
    setSelectedNumber(event.target.value);
  };
  const calculatepoints = () =>
  {
    playClick();
    setShowPopup(true);
  }
  const closePopUp = () => {
    playClick();
    setShowPopup(false);
  };
  const toogleMenu = () => {
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: PhasePage,
      currentComponentText: "stakepage",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: false,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };
  return (
    <>
  
    <div className={`${showPopup ? "bad" : "info-img"}`}>
      <img
        onClick={() => {
          toogleMenu();
        }}
        src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
        className="cancel-imgpoints"
        style={{ cursor: "pointer", pointerEvents: "all" }}
      />
      <div
        className="menupointer"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          pointerEvents: "all",
        }}
      >
        <div className="row" style={{padding:"40px"}}>
        <div class="streakBreakRow"><span class="streakBreakText">STAKING <br/>Explanation</span></div>
        <p className="points-para">
        double your tokens by staking your daily rewards.
        </p>
        <div className="table col-12">
          <table className="pointstable" style={{alignItems:"center"}}>
            <thead>
            <tr>
            <th>Day <br/>count</th>
            <th>Day of Normal <br/>
            withdrawal</th>
            <th>day of Stake<br/>
            withdrawal</th>
            </tr>
            </thead>
            <tr>
              <td>
              day 1
              </td>
              <td>
              N + 1
              </td>
              <td>
              2N + 1
              </td>
            </tr>
            <tr>
              <td>
              day 2
              </td>
              <td>
             N + 2
              </td>
              <td>
             2N + 2
              </td>
            </tr>
            <tr>
              <td>
              .
              </td>
              <td>
              .
              </td>
              <td>
              .
              </td>
            </tr>
            <tr>
              <td>
              n
              </td>
              <td>
              n
              </td>
              <td>
              n
              </td>
            </tr>
            <tr className="points-dis">
              <td colSpan="3">
                N - distribution end day
              </td>
            </tr>
          </table>
        </div>
          <h3 className="withdraw-points">
          withdrawal day calculator
          </h3>
          <div className="col-12">
            <div className="withdraa-sec">
              <h6 className="ex-points">
              example,
              </h6>
              <p className="p-distri">
              If distribution end day (n) is <select
        id="number-select"
        value={selectedNumber}
        onChange={handleChange}
        className="p-1  rounded-lg w-full max-w-sm"
      >
        <option value="" disabled>
          80
        </option>
        {Array.from({ length: 80 }, (_, i) => i + 1).map((num) => (
          <option key={num} value={num}>
            {num}
          </option>
        ))}
      </select> days
              </p>
              <button className="points-cal" onClick={calculatepoints}>Calculate</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    {showPopup && (
  <div className="overlay">
    <div className="popup">
      <div className="popup-content">
        <h2 className="epic2">Withdrawal Calculator</h2>
        <img
          src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
          className="cancel-img"
          onClick={() => {
            closePopUp();
          }}
          alt="Close"
        />
        <table className="pointstable" style={{ alignItems: "center" }}>
          <thead>
            <tr>
              <th>Day <br /> count</th>
              <th>Day of Normal <br /> withdrawal</th>
              <th>Day of Stake <br /> withdrawal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Day 1</td>
              <td>Day {<span>{Number(selectedNumber) + 1}</span>}</td>
              <td>Day {<span>{Number(2*selectedNumber) + 1}</span>}</td>
            </tr>
            <tr>
              <td>Day 2</td>
              <td>Day {<span>{Number(selectedNumber) + 2}</span>}</td>
              <td>Day {<span>{Number(2*selectedNumber) + 2}</span>}</td>
            </tr>
            <tr>
              <td>.</td>
              <td>.</td>
              <td>.</td>
            </tr>
            <tr>
              <td>
               Day <span>{selectedNumber}</span>
              </td>
              <td>Day {<span>{Number(selectedNumber) + Number(selectedNumber)}</span>}</td>
              <td>Day {<span>{Number(2*selectedNumber) + Number(selectedNumber)}</span>}</td>
            </tr>
            <tr className="points-dis">
              <td colSpan="3">N - {selectedNumber}</td>
            </tr>
          </tbody>
        </table>
        <button className="points-done" onClick={() => {
            closePopUp();
          }}>Done</button>
      </div>
    </div>
  </div>
)}
    </>
  );
};
export default Info;
